import styled from 'styled-components';
import { widthResize, widthFull, bgLight, text, textMuted, border, primary, heightHeader } from '../Resources/Theme';

const PageWrapper = styled.div`
  margin-left: ${props => props.resize ? widthResize : widthFull};
  width: calc(100% - ${props => props.resize ? widthResize : widthFull});
  transition: .5s;
  background: ${bgLight};
  padding-top: ${heightHeader};
  min-height: 100vh;

  @media (max-width: 992px) {
    width: 100%;
    margin-left: 0;
  }
`;

PageWrapper.BgTop = styled.div`
  background: transparent;
  width: 100%;
  min-height: auto;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 6px;
  color: ${text};
  padding: 24px 28px 4px;
`;

PageWrapper.Eyebrow = styled.div`
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: ${textMuted};
`;

PageWrapper.Title = styled.h1`
  margin: 0;
  align-self: flex-start;
  font-weight: 700;
  font-size: 1.75rem;
  letter-spacing: -0.03em;
  color: ${text};
  line-height: 1.2;

  @media (max-width: 992px) {
    font-size: 1.4rem;
  }
`;

PageWrapper.Subtitle = styled.p`
  margin: 0;
  max-width: 560px;
  font-size: 0.9rem;
  color: ${textMuted};
  line-height: 1.45;
`;

PageWrapper.Body = styled.div.attrs({ className: 'page-body' })`
  position: relative;
  top: 0;
  padding: 16px 28px 40px;
  min-height: calc(100vh - 160px);
`;

PageWrapper.BreadCrumb = styled.div`
  font-weight: 400;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  color: ${textMuted};
  font-size: 0.8rem;
  
  @media (max-width: 992px) {
    display: flex;
  }
`;

PageWrapper.BreadCrumb.Title = styled.span`
  margin-right: .45rem;
  display: flex;
  font-weight: ${props => props.active ? '600' : '400'};
  color: ${props => props.active ? primary : textMuted};
  align-self: center;
`;

PageWrapper.BreadCrumb.Icon = styled.div`
  align-self: center;
  transform: rotate(135deg);
  content: '';
  width: 5px;
  height: 5px;
  border-width: 1px 0 0 1px;
  border-style: solid;
  border-color: ${border};
  margin-right: .45rem;
`;

export default PageWrapper;
